import { render, staticRenderFns } from "./todayCourseLive.vue?vue&type=template&id=4c5ced8c&scoped=true"
import script from "./todayCourseLive.vue?vue&type=script&lang=js"
export * from "./todayCourseLive.vue?vue&type=script&lang=js"
import style0 from "./todayCourseLive.vue?vue&type=style&index=0&id=4c5ced8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5ced8c",
  null
  
)

export default component.exports